<template>
<div class="vlive">
 <router-view :param="param"></router-view>

</div>
</template>

<script>
import {mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'
export default {
    name: 'vlive',
    mixins: [initPage],
    data() {
        return {
            param: {
                status: '',
                subject: ''
            }
        }
    },
    mounted() {
        this.setParams(this._.cloneDeep(this.param))
    },
    methods: {
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vlive {
}
</style>
